import React from 'react'
import Link from 'next/link';
import ResourceCard from '../../components/ResourceCard';

const HomeResources = ({ data }) => {
    return (
        <div className="resources-container pb-lg-5 py-md-3 px-md-5 py-5 px-2 ">
            <div className="row">
                <div className="col py-md-5">
                    <h2 className="resources-title text-center">
                        Get Inspired From <span className="theme-text">Experts</span>
                    </h2>
                    <div className="resources-sub-title text-center">
                        Here's a treasure trove of content from seasoned experts from our past events
                    </div>
                </div>
            </div>
            <div className='d-lg-block d-large d-md-block d-sm-none d-xs-none'>
                <div className="row flex-row ">
                    <div className="col-lg-3 ps-4 col-md-12 col-sm-12 col-xs-12 aliging_center">
                        {data.length > 0 ?
                            <>
                                <span className='resource-text'>
                                    Be it blogs, slides, videos, e-books & GitHub links, we have it all! Most of them are from our recent technical conferences and we are glad to make them available for you FREE!!
                                </span>
                            </>
                            : ''}
                        {data.length && <div className="py-4 d-xl-block d-lg-block community-btn d-none ">
                            <Link href="/resources">
                                <button className="btn btn-theme px-3" type="button>">
                                    View all Resources&nbsp;
                                    <i className="fas fa-chevron-circle-right arrow"></i>
                                </button>
                            </Link>
                        </div>}
                    </div>
                    <div className="col-lg-9 col-md-12 px-4 col-sm-12 col-xs-12 d-lg-block d-md-block d-sm-none d-xs-none">
                        <div className="row">
                            {data.slice(0, 3).map((resource, idx) => (
                                <div className="col-md-4 mb-3" key={idx}>

                                    <ResourceCard
                                        resource={resource}
                                        homePage={true}
                                        backgroundUrl={
                                            resource.poster_url
                                                ? resource.poster_url
                                                : "https://image-dock-uploads-be.s3.ap-south-1.amazonaws.com/image.2021-04-19T04%3A54%3A26.365Z"
                                        }
                                    />

                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 px-4 col-sm-12 col-xs-12 d-lg-block d-md-block d-sm-none d-xs-none">
                        {data.length > 3 && (
                            <div className="row" >
                                {data.slice(3, 8).map((resource, idx) => (
                                    <div
                                        className="col-md-3 mb-3"
                                        style={{ height: "302px" }}
                                        key={idx}
                                    >
                                        <ResourceCard
                                            resource={resource}
                                            homePage={true}
                                            backgroundUrl={
                                                resource.poster_url
                                                    ? resource.poster_url
                                                    : "https://image-dock-uploads-be.s3.ap-south-1.amazonaws.com/image.2021-04-19T04%3A54%3A26.365Z"
                                            }
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/*displaying only in sm & xs screen*/}
            <div className="d-lg-none d-md-none d-sm-block d-xs-block">
                <div className="row d-flex justify-content-center">
                    {data.slice(0, 8).map((resource, idx) => (
                        <div
                            className="col-11 mb-3"
                            // style={{ height: "302px" }}
                            key={idx}
                        >
                            <ResourceCard
                                resource={resource}
                                homePage={true}
                                backgroundUrl={
                                    resource.poster_url
                                        ? resource.poster_url
                                        : "https://image-dock-uploads-be.s3.ap-south-1.amazonaws.com/image.2021-04-19T04%3A54%3A26.365Z"
                                }
                            />
                        </div>
                    ))}
                </div>
            </div>
            {data.length > 4 && <div className="row">
                <div className="col-12 py-4 d-xl-none d-lg-none community-btn d-md-block d-sm-block">
                    <Link href="/resources">
                        <button className="btn btn-theme px-3" type="button>">
                            View all Resources&nbsp;
                            <i className="fas fa-chevron-circle-right arrow"></i>
                        </button>
                    </Link>
                </div>
            </div>
            }
            <style jsx>{`

                    .resources-container{
                        background: #f6f9fc !important;
                    }

                    .resource-text{
                        font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 19px;
                    line-height: 26px;
                    text-align: justify;
                    color: #572148;
                    }

                    .resources-container .resources-title {
                        color: #572148;
                        font-weight: 700;
                        font-size: 50px;
                        font-family: "Nunito";
                    }

                    .resources-container .resources-title .theme-text {
                        color: #FB5850;
                    }
                    .d-large{
                        display: block;
                    }

                    .resources-container .resources-sub-title {
                        font-family: 'Nunito';
                        font-weight: 400;
                        font-size: 22px;
                        color: #572148;
                    }


.comm_title {
  font-family: Prompt;
  font-style: normal;
  font-weight: bold;
  font-size: 3rem;
  line-height: 4.5rem;
  color: #572148;
  text-align: center;
}

.comm_title_comm {
  color: #fb5850;
  font-family: Caveat Brush;
  font-weight: normal;
  font-size: 3.5rem;
  line-height: 4rem;
  position: relative;
}

    .view_more{
      text-align: end;
    color: #FB5850;
    font-weight: 400;
    }

    .aliging_center{
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

	.featured_text{
	  margin-top: 100px
      font-family: Prompt;
      font-weight: bold;
      font-size: 2rem;
      line-height: 2.5rem
      letter-spacing: 0.03em;
      color: #572148;
      display: block;
	  }

	  .event_text {
      font-family: "Caveat Brush", cursive;
      font-size: 2.5rem;
      line-height: 3rem;
      color: #FB5850;
      font-weight: normal;
      position: relative;
	  }

	  .spark_image_placeholder {
	    position: absolute;
      top: -3px;
      right: -25px;
	  }

	  .spark_image{
		  height: 32px;
	  }

	  @media only screen and (max-width: 1950px) {
		.aliging_center{
			margin-top: 20px;
		}
	}

	  @media only screen and (max-width: 1366px) {
		.aliging_center{
			margin-top: 20px;
		}
	}

    @media only screen and (max-width: 992px) {
		.aliging_center{
			margin-top: 0px;
		}
        .d-large{
            display: none;
        }
        .community-btn{
            text-align: center;

        }
        .resource-text{
            text-align: center;
            margin-top: 20px;
            margin-bottom: 20px;
        }
      .featured_text{
        text-align: center;
        margin-bottom: 20px;
      }
    }
    @media only screen and (max-width: 640px) {
      .featured_text{
		font-size: 1.4rem;
      }
	  .event_text {
		font-size: 1.8rem;
	  }
    }
		`}</style>

        </div>
    )
}

export default HomeResources
